import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import themePropTypes from './theme-prop-types';
import defaultAppConfigPropTypes from '../app/default-app-prop-types';
import { AppState } from '../state/MyStateProvider';
import { APP_STATE_ACTION_TYPE_USER_THEME, APP_STATE_ACTION_TYPE_USE_SYS_THEME } from '../state/seed-states';
import useSystemTheme from './theme-helpers';

const MyThemeProvider = ({
  children,
  themeDefaultTheme,
  themeSupportedThemes,
  themeThemes,
  font,
  fontSize,
}) => {
  const { state } = React.useContext(AppState);
  const userTheme = state[APP_STATE_ACTION_TYPE_USER_THEME];
  const useSysTheme = state[APP_STATE_ACTION_TYPE_USE_SYS_THEME];
  const sysTheme = useSystemTheme();

  let theme = themeDefaultTheme;
  if (useSysTheme) {
    if (themeSupportedThemes.includes(sysTheme)) {
      theme = sysTheme;
    } else {
      // console.warn(`Warning: User's preffered theme: '${sysTheme}' is not supported`);
      theme = themeDefaultTheme;
    }
  } else if (userTheme && themeSupportedThemes.includes(userTheme)) {
    theme = userTheme;
  }

  // Add font to theme.
  const fontTheme = themeThemes[theme];
  fontTheme.typography = {
    fontSize,
    fontFamily: [
      font,
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif',
    ],
  };

  return (
    <ThemeProvider theme={createMuiTheme(fontTheme)}>
      {children}
    </ThemeProvider>
  );
};

MyThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  themeDefaultTheme: PropTypes.string,
  themeSupportedThemes: PropTypes.arrayOf(PropTypes.string),
  themeThemes: PropTypes.objectOf(themePropTypes),
  font: PropTypes.string,
};

MyThemeProvider.defaultProps = defaultAppConfigPropTypes;

export default MyThemeProvider;
